import React, { ReactNode, useState } from 'react';

import classNames from 'classnames';

import { useStoreMobx } from 'mobx/helpers';

import { useAppSelector } from '../redux/hooks';
import { sliceEnvironment } from '../redux/slice/slice.environment';
import Loader from './Loader';
import './Page.Simple.scss';

// Optional Props
interface Props {
  title?: string;
  children: ReactNode;
  description?: string;
  isLoading?: boolean;
  className?: string;
}

const SimplePage = ({ title, description, children, isLoading, className }: Props) => {
  const store = useStoreMobx();
  const [isLogoInError, setIsLogoInError] = useState(false);
  const environment = useAppSelector(sliceEnvironment.selectors.environment);

  const logoOnError = () => setIsLogoInError(true);

  return (
    <div className={`SimplePage-container ${title} ${className}`}>
      {isLoading ? (
        <Loader />
      ) : (
        <img
          className={classNames('logo', isLogoInError && 'logo-error')}
          alt='logo'
          src={`${environment.REACT_APP_BUCKET_BASEURL}/brokers/${store.brokerName}/itd/logo.png`}
          onError={logoOnError}
        />
      )}
      <div className='title'>{title}</div>
      <div className='description'>{description}</div>
      {children}
    </div>
  );
};

export default React.memo(SimplePage);
